import { render, staticRenderFns } from "./comando-chip.vue?vue&type=template&id=4d43db94&scoped=true&"
import script from "./comando-chip.vue?vue&type=script&lang=js&"
export * from "./comando-chip.vue?vue&type=script&lang=js&"
import style0 from "./comando-chip.vue?vue&type=style&index=0&id=4d43db94&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43db94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d43db94')) {
      api.createRecord('4d43db94', component.options)
    } else {
      api.reload('4d43db94', component.options)
    }
    module.hot.accept("./comando-chip.vue?vue&type=template&id=4d43db94&scoped=true&", function () {
      api.rerender('4d43db94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/comando-chip/comando-chip.vue"
export default component.exports